import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'gatsby';
import { AnimatePresence } from 'framer-motion';

function MenuItemDropdown({ item, label, source, headerTransparent }) {
	const [isOpen, setIsOpen] = useState(false);

	const onGroupButtonClick = useCallback(() => {
		setIsOpen(prev => !prev);
	}, []);

	useEffect(() => {
		const handleClickOutside = event => {
			const wrapper = document.querySelector(
				`[data-id="${label}-group-wrapper"]`
			);
			if (isOpen && wrapper && !wrapper.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen, label]);

	useEffect(() => {
		const handleEscapeKey = event => {
			if (event.key === 'Escape' && isOpen) {
				setIsOpen(false);
			}
		};

		document.addEventListener('keydown', handleEscapeKey);
		return () => {
			document.removeEventListener('keydown', handleEscapeKey);
		};
	}, [isOpen]);

	const DropdownMenuItem = ({ item }) => {
		const slug = item.url;
		const title = item.name;

		if (source && source === 'mobilemenu') {
			return (
				<Link
					to={`${slug && slug.length < 2 ? '' : slug}`}
					className="block py-2 px-2 hover:underline font-normal"
				>
					{item.name}
				</Link>
			);
		}

		return (
			<div
				className="p-4 block font-medium  text-[15px] hover:bg-gray-50 focus:outline-none focus:bg-gray-50  text-gray-700 hover:text-brand-600 transition-colors duration-150 ease-in"
				style={{ paddingBottom: '17px' }}
			>
				<Link to={`${slug}`} title={title || item.name}>
					{item.name}
				</Link>
			</div>
		);
	};

	if (source && source === 'mobilemenu') {
		return (
			<div className="py-4 px-8 border-b border-gray-300">
				<span className="font-semibold mb-2 block">{label}</span>
				{item.submenu[0].menuItems.map(item => (
					<DropdownMenuItem
						key={item.id}
						item={item}
						type={item.type}
					/>
				))}
			</div>
		);
	}
	return (
		<div
			data-id={`${label}-group-wrapper`}
			className={`${
				headerTransparent
					? 'text-white hover:text-brand-200'
					: 'text-gray-900 hover:text-black'
			} relative inline-block text-left font-normal text-base transition-colors duration-150 ease-in !ml-[28px] ${
				label === 'Windows' && '!ml-[40px] !mr-[12px]'
			}`}
			data-type={item.dropdownonesection}
		>
			<div
				onClick={onGroupButtonClick}
				className={`-my-1 -mx-3 px-3 py-6 flex items-center transition-colors duration-150 ease-in rounded-lg focus:outline-none button-active-bhvr font-medium text-[15px] font-display text-base 
          relative cursor-pointer
          text-gray-900 hover:text-black`}
			>
				<>
					<span className="text-[#1a1a1a] font-[600]">{label}</span>
					<svg
						className={`w-5 h-5 opacity-75 rotate-0  duration-75 transition-transform ease-in ${
							isOpen ? 'transform rotate-180' : ''
						}`}
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M19 9l-7 7-7-7"
						/>
					</svg>
				</>
			</div>
			<AnimatePresence>
				<div
					data-id={`${label}-popup-box`}
					className={`shadow-xl absolute !left-[-12px] !top-[56px] origin-top-left bg-white divide-y divide-gray-50 rounded-md border border-gray-900/10 outline-none" ${
						isOpen ? 'nav-opened' : 'nav-closed'
					}`}
					style={{ width: '20rem', maxHeight: '500px', overflowY: 'auto' }}
				>
					<div>
						{item.submenu[0].menuItems.map(item => (
							<DropdownMenuItem
								key={item.id}
								item={item}
								type={item.type}
							/>
						))}
					</div>
				</div>
			</AnimatePresence>
		</div>
	);
}

export default MenuItemDropdown;
